<template>
  <sliding-modal
    class="step3-sliding-modal"
    :feed-name="getModalTitle"
    :is-product-pages="isProductPages"
    :campaign="campaign"
    :is-bulk="isBulk"
    :display-close-button="false"
    @close="close"
  >
    <div class="elements-sliding-container">
      <Step3
        :is-bulk="true"
        :is-edit-mode="true"
        :is-edit-bulk-format="isEditBulkFormat"
        :current-feed-edit-index="currentFeedEditIndex"
        :is-product-pages="isProductPages"
        :campaign-id-from-product-pages="campaignId"
        :selected-product-id="selectedProductId"
        :comes-from-step-one="comesFromStepOne"
        :videos-attached-on-product="videosAttachedOnProduct"
        @update-current-feed="updateCurrentFeed"
        @update-campaign="updateCampaign"
        @update-product="updateProduct"
        @close-elements-modal="close"
      />
    </div>
  </sliding-modal>
</template>

<script>
import SlidingModal from "@/components/shared/SlidingModal.vue";
import Step3 from "@/components/create-campaign-steps/Step3.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    SlidingModal,
    Step3,
  },
  props: {
    currentFeedEditIndex: { type: Number, required: true },
    isEditBulkFormat: { type: Boolean, required: true },
    isProductPages: { type: Boolean, default: false },
    campaignId: { type: String, default: null },
    selectedCurrentFeedEdit: { type: Object, default: null },
    selectedProductId: { type: [Number, String], default: null },
    isBulk: { type: Boolean, default: false },
    comesFromStepOne: { type: Boolean, default: false },
    videosAttachedOnProduct: { type: Array, default: () => [] },
  },
  data() {
    return {
      isNewVideoAdded: false,
      campaign: null,
    };
  },
  computed: {
    ...mapState({
      products: (state) => state.product.products,
    }),
    ...mapGetters({
      currentFeedEdit: "campaign/currentFeedEdit",
      feedList: "campaign/feedList",
      getVideos: "video/getVideos",
      siteId: "account/getSiteId",
      singleCampaign: "campaign/getSingle",
    }),
    getModalTitle() {
      return !this.isEditBulkFormat
        ? this.currentFeedEdit.feedName
        : this.$t("create.bulk.playerModal.allFeeds");
    },
  },
  async created() {
    await this.$store.dispatch("product/getProducts", {
      siteId: this.siteId,
      isProductListView: false,
    });
    this.campaign = {
      ...structuredClone(this.singleCampaign()),
      videos: !this.isEditBulkFormat
        ? [...this.currentFeedEdit.videos]
        : this.feedList.length > 0
        ? [...this.feedList[0].videos]
        : [],
    };
  },
  methods: {
    close() {
      this.$emit("close-elements-modal");
    },
    async updateCurrentFeed() {
      this.$store.commit("campaign/updateFeedList", {
        currentFeedEdit: this.currentFeedEdit,
        index: this.currentFeedEditIndex,
      });

      await this.$store.dispatch("campaign/updateFeed", {
        campaignId: this.campaignId,
        feedIndex: this.currentFeedEditIndex,
      });

      this.$emit("update-current-feed");

      this.close();
    },
    updateCampaign(payload) {
      this.campaign.videos.push(payload);
    },
    updateProduct(productId, newVideos) {
      this.$emit("update-product", productId, newVideos);
    },
  },
};
</script>

<style lang="scss" scoped>
.elements-sliding-container {
  position: relative;
  height: 100%;
}
.subtitle {
  @include base-font;
  @include font-normal;
  font-weight: 400;
  text-align: center;
  width: 70%;
  margin: 0 auto 24px;
}

.buttons {
  width: calc(25% + 12px);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: absolute;
  bottom: 80px;
  left: 0;
  height: 56px;
  background-color: white;
  filter: drop-shadow(0px -2px 8px rgba(0, 0, 0, 0.15));
}

.flex-button {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
